import { Button, Grid, Typography } from "@mui/material";
import React, { useEffect, useRef } from "react";
import AddIcon from "@mui/icons-material/Add";
import { showWarningSnackbar } from "../../../components/snackBar/snakbar";
import { useState } from "react";
import Attachment from "../../NewFigma/AddCustomer/attachment";
import theme from "../../../styles/Themecolors";
import { useThemes } from "../../../components/Theme/theme";
import CustomTooltip from "../../../components/CustomTooltip";
import InfoTooltip from "../../../components/_components/button/infoButton";
import { uploadInfo } from "../../../utils/Data/StaticData";
import {
  ATTACHMENT_MAX_COUNT,
  validateAttachmentSelection,
} from "../../../utils/attachmentValidation";

function ItemAttachment({
  attachments,
  setAttachments,
  path,
  setInitialAttachments,
  itemData,
  params,
  data,
  setDocuments,
}) {
  const imageRef = useRef();
  const isAddImagesDisabled = data?.itemName === "" || params?.view === true;
  function handleTextKeyDown(
    e,
    name,
    currentId,
    nextId,
    required,
    warMsg,
    prevID
  ) {
    if (e.key === "Tab" && e.shiftKey) {
      e.preventDefault();
      e.stopPropagation();
      const prevElement = document.getElementById(prevID);
      prevElement?.focus();
      return;
    }

    if (e.key === "Enter" || (e.key === "Tab" && !e.shiftKey)) {
      if (required && e.target.value === "") {
        e.preventDefault();
        e.stopPropagation();

        const currentElement = document.getElementById(currentId);
        currentElement?.focus();
      } else {
        e.preventDefault();
        e.stopPropagation();
        const nextElement = document.getElementById(nextId);
        nextElement?.focus();
      }
    }
  }
  const handleFileChange = (event) => {
    const { validFiles, errorMessage } = validateAttachmentSelection(
      event.target.files,
      attachments
    );

    if (validFiles.length > 0) {
      setAttachments((currentAttachments) => {
        const remainingSlots = ATTACHMENT_MAX_COUNT - currentAttachments.length;
        if (remainingSlots <= 0) {
          return currentAttachments;
        }

        const filesToAdd = validFiles.slice(0, remainingSlots);
        const newAttachments = filesToAdd.map((file) => ({
          attachmentid: Date.now() + file.name,
          imagename: path + "${id}/" + Date.now() + file.name,
          expiredtimestamp: 0,
          documentname: file.name,
          type: file.type,
          imageurl: URL.createObjectURL(file),
          file,
        }));

        const filteredNewAttachments = newAttachments.filter(
          (newAttachment) =>
            !currentAttachments.some(
              (attachment) =>
                attachment.documentname === newAttachment.documentname
            )
        );

        return [...currentAttachments, ...filteredNewAttachments];
      });
    }

    if (errorMessage) {
      showWarningSnackbar(errorMessage);
    }

    event.target.value = "";
    if (imageRef.current) {
      imageRef.current.value = "";
    }
  };
  console.log(attachments, "attach");
  const updateAttachmentName = (id, newName) => {
    console.log(id, newName, "newName");
    setAttachments(
      attachments.map((attachment) =>
        attachment.attachmentid === id
          ? { ...attachment, documentname: newName }
          : attachment
      )
    );
  };
  function getItemAttachment(itemData) {
    if (itemData?.relateditemimages?.length > 0) {
      let items = [];
      itemData?.relateditemimages.map((item, ind) => {
        if (item.documentname !== null) {
          items.push({
            slNo: "",
            attachmentid: item.attachmentid,
            documentname: item.documentname,
            imagename: item.imagename,
            action: "",
            imageurl: item.imageurl,
            type: item?.type,
          });
        }
      });
      setAttachments([...items]);
      setDocuments([...items]);
      setInitialAttachments([...items]);
    }
  }
  const { theme } = useThemes();
  useEffect(() => {
    getItemAttachment(itemData);
  }, [itemData]);
  return (
    <Grid
      item
      container
      style={{
        justifyContent: { xs: "center", lg: "flex-start" },
      }}
    >
      <Grid item lg={1} xs={12}>
        <Typography
          sx={{
            fontWeight: "bold",
            padding: "6px",
            color: data?.itemName ? theme?.palette?.TmId.id.toString().includes("9")
            ? "white"
            : "black" : "gray", // Change color when disabled
          }}
          variant="h2"
        >
           Documents
        </Typography>
      </Grid>
      <Grid lg={3} xs={12} sx={{ ml: "3px", mb: "5px" }}>
        <div
          style={{display:"flex"}}
          >
            <div>
        <input
          tabIndex="0"
          ref={imageRef}
          type="file"
          id="fileInput"
          onChange={handleFileChange}
          multiple
          onKeyDown={(e) => {
            const warMsg = "";
            const name = "fileInput";
            const currentId = "fileInput";
            const nextId = "save";
            const prevID = "remarks";
            const required = false;

            handleTextKeyDown(
              e,

              name,
              currentId,
              nextId,
              required,
              warMsg,
              prevID
            );
          }}
          style={{ display: "none", outline: "none" }}
          accept="
        application/msword,
        application/pdf,
        application/vnd.openxmlformats-officedocument.wordprocessingml.document,
        application/vnd.ms-excel,
        application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
        image/jpeg,
        image/jpg,
        image/png
      "
        />
        <span>
              <Button
            onClick={() => imageRef?.current?.click()}
            size="small"
            variant="contained"
            id="Button"
           disabled={isAddImagesDisabled}
            // disabled={true}
            sx={{
              fontSize: "12px",
              display: params?.view ? "none" : "block",
            }}
            disableRipple={false}
          >
            <AddIcon fontSize="15px" />
            {" ADD DOCUMENT"}
            {attachments.length > 0 && (
              <span style={{ color: "white" }}>
                {"\xa0" + `(${attachments.length} out of 6)`}
              </span>
            )}
          </Button>
           </span>
          </div>
          <div>
           <span>
              <InfoTooltip title={uploadInfo} disabled={isAddImagesDisabled} />
            </span>
            </div>
           
        </div>
      </Grid>
      {attachments.length > 0 && (
          <Grid lg={12}>
            <Attachment
              view={params?.view}
              attachments={attachments}
              setAttachments={setAttachments}
              updateAttachmentName={updateAttachmentName}
            />
          </Grid>
        )}
    </Grid>
  );
}

export default ItemAttachment;
